import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _defineStyle, _dark, _active, _defineStyle2;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { typography_default } from "./chunk-HOOF7HHD.mjs";
import { inputTheme } from "./chunk-WFLWAEKG.mjs";
import { runIfFn } from "./chunk-EBS47JIL.mjs";

// src/components/number-input.ts
import { numberInputAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/styled-system";
import { calc, cssVar } from "@chakra-ui/theme-tools";
var _createMultiStyleConf = createMultiStyleConfigHelpers(parts.keys),
  defineMultiStyleConfig = _createMultiStyleConf.defineMultiStyleConfig,
  definePartsStyle = _createMultiStyleConf.definePartsStyle;
var $stepperWidth = cssVar("number-input-stepper-width");
var $inputPadding = cssVar("number-input-input-padding");
var inputPaddingValue = calc($stepperWidth).add("0.5rem").toString();
var $bg = cssVar("number-input-bg");
var $fg = cssVar("number-input-color");
var $border = cssVar("number-input-border-color");
var baseStyleRoot = defineStyle((_defineStyle = {}, _defineProperty(_defineStyle, $stepperWidth.variable, "sizes.6"), _defineProperty(_defineStyle, $inputPadding.variable, inputPaddingValue), _defineStyle));
var baseStyleField = defineStyle(function (props) {
  var _a, _b;
  return (_b = (_a = runIfFn(inputTheme.baseStyle, props)) == null ? void 0 : _a.field) != null ? _b : {};
});
var baseStyleStepperGroup = defineStyle({
  width: $stepperWidth.reference
});
var baseStyleStepper = defineStyle((_defineStyle2 = {
  borderStart: "1px solid",
  borderStartColor: $border.reference,
  color: $fg.reference,
  bg: $bg.reference
}, _defineProperty(_defineStyle2, $fg.variable, "colors.chakra-body-text"), _defineProperty(_defineStyle2, $border.variable, "colors.chakra-border-color"), _defineProperty(_defineStyle2, "_dark", (_dark = {}, _defineProperty(_dark, $fg.variable, "colors.whiteAlpha.800"), _defineProperty(_dark, $border.variable, "colors.whiteAlpha.300"), _dark)), _defineProperty(_defineStyle2, "_active", (_active = {}, _defineProperty(_active, $bg.variable, "colors.gray.200"), _defineProperty(_active, "_dark", _defineProperty({}, $bg.variable, "colors.whiteAlpha.300")), _active)), _defineProperty(_defineStyle2, "_disabled", {
  opacity: 0.4,
  cursor: "not-allowed"
}), _defineStyle2));
var baseStyle = definePartsStyle(function (props) {
  var _a;
  return {
    root: baseStyleRoot,
    field: (_a = runIfFn(baseStyleField, props)) != null ? _a : {},
    stepperGroup: baseStyleStepperGroup,
    stepper: baseStyleStepper
  };
});
function getSize(size) {
  var _a, _b, _c;
  var sizeStyle = (_a = inputTheme.sizes) == null ? void 0 : _a[size];
  var radius = {
    lg: "md",
    md: "md",
    sm: "sm",
    xs: "sm"
  };
  var _fontSize = (_c = (_b = sizeStyle.field) == null ? void 0 : _b.fontSize) != null ? _c : "md";
  var fontSize = typography_default.fontSizes[_fontSize];
  return definePartsStyle({
    field: _objectSpread(_objectSpread({}, sizeStyle.field), {}, {
      paddingInlineEnd: $inputPadding.reference,
      verticalAlign: "top"
    }),
    stepper: {
      fontSize: calc(fontSize).multiply(0.75).toString(),
      _first: {
        borderTopEndRadius: radius[size]
      },
      _last: {
        borderBottomEndRadius: radius[size],
        mt: "-1px",
        borderTopWidth: 1
      }
    }
  });
}
var sizes = {
  xs: getSize("xs"),
  sm: getSize("sm"),
  md: getSize("md"),
  lg: getSize("lg")
};
var numberInputTheme = defineMultiStyleConfig({
  baseStyle: baseStyle,
  sizes: sizes,
  variants: inputTheme.variants,
  defaultProps: inputTheme.defaultProps
});
export { numberInputTheme };